export default function () {
	return {
		showModal: false,
		//Stops video playback by resetting the source when modal is closed.
		videoPause() {
			const frameSource = document
				.querySelectorAll("iframe")
				.forEach((item) => (item.src = item.src));
			window.videoModal = videoModal;
		},
	};
}